module.exports = __webpack_public_path__ + "img/content_image1.ac3d0b4a.png";